export class JobOfffer {
    public name: string;
    public linkTo: string;
    constructor(name: string, linkTo: string) {
        this.name = name;
        this.linkTo = linkTo;
    }
}
